module.exports = __webpack_public_path__ + "img/pasta-icon.af8445bd.png";